/**
 * @module cercaliagl/view/VZoom
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import { MDCRipple } from '@material/ripple';
import BaseView from './BaseView';
var ClassName = {
    GPS: 'gps',
    D3: 'd3',
    ROTATE: 'rotate',
    ZOOM: 'zoom',
    ZOOM_IN: 'zoomin',
    ZOOM_OUT: 'zoomout',
};
/**
 * @enum {string}
 */
export var EventType = {
    ZOOM_IN: 'zoomin',
    ZOOM_OUT: 'zoomout',
    GPS: 'gps',
    D3: 'd3',
    ROTATE: 'rotate',
    ROTATE_LEFT: 'rotate_left',
    ROTATE_RIGHT: 'rotate_right',
};
function createFabButton(iconSuffix, className) {
    return "\n    <button type=\"button\" class=\"mdc-fab mdc-fab--touch ".concat(className, "\">\n      <div class=\"mdc-fab__ripple\"></div>\n      <span class=\"icon-").concat(iconSuffix, " mdc-fab__icon\"></span>\n      <div class=\"mdc-fab__touch\"></div>\n    </button>\n  ");
}
/**
 * @return {JQuery} Create view
 */
function createView() {
    var html = "\n    <div class=\"mdc-touch-target-wrapper\">\n      <div class=\"rotate\">\n        <div class=\"compass\"></div>\n        <div class=\"arrow left\"></div>\n        <div class=\"arrow right\"></div>\n      </div>\n      <button type=\"button\" class=\"mdc-fab mdc-fab--touch ".concat(ClassName.D3, "\">\n        <div class=\"mdc-fab__ripple\"></div>\n        <span class=\"mdc-fab__icon mode\">3D</span>\n        <div class=\"mdc-fab__touch\"></div>\n      </button>\n      ").concat(createFabButton('gps', ClassName.GPS), "\n      <div class=\"").concat(ClassName.ZOOM, "\">\n        ").concat(createFabButton('add', ClassName.ZOOM_IN), "\n        ").concat(createFabButton('remove', ClassName.ZOOM_OUT), "\n      </div>\n    </div>\n  ");
    return $(html);
}
/**
 * @classdesc
 */
var VZoom = /** @class */ (function (_super) {
    __extends(VZoom, _super);
    /**
     * @constructor
     */
    function VZoom() {
        var _this = this;
        var jqElement = createView();
        _this = _super.call(this, jqElement) || this;
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    VZoom.prototype.initialize_ = function () {
        var _this = this;
        if (this.jqElement_ === null) {
            return;
        }
        var jqMdcFab = this.jqElement_.find('.mdc-fab');
        if (!jqMdcFab) {
            return;
        }
        jqMdcFab.each(function (index, elem) { return new MDCRipple(elem); });
        this.jqElement_.find(".".concat(ClassName.ZOOM_IN)).click(function () { return _this.emit(EventType.ZOOM_IN, {}); });
        this.jqElement_.find(".".concat(ClassName.ZOOM_OUT)).click(function () { return _this.emit(EventType.ZOOM_OUT, {}); });
        this.jqElement_.find(".".concat(ClassName.GPS)).click(function () { return _this.emit(EventType.GPS, {}); });
        this.jqElement_.find(".".concat(ClassName.D3)).click(function () { return _this.emit(EventType.D3, {}); });
        this.jqElement_.find('.compass').click(function () { return _this.emit(EventType.ROTATE, {}); });
        this.jqElement_.find('.rotate .left').click(function () { return _this.emit(EventType.ROTATE_LEFT, {}); });
        this.jqElement_.find('.rotate .right').click(function () { return _this.emit(EventType.ROTATE_RIGHT, {}); });
    };
    /**
     * @param {number} deg Degrees
     */
    VZoom.prototype.rotateCompass = function (deg) {
        this.jqElement_.find('.compass').css({ transform: "rotate(".concat(deg, "deg)"), transition: '0.5' });
    };
    /**
     * @param {string} className ClassName
     * @override
     */
    VZoom.prototype.show = function (className) {
        this.jqElement_.find(".".concat(className)).show();
    };
    /**
     * @param {string} className ClassName
     * @override
     */
    VZoom.prototype.hide = function (className) {
        this.jqElement_.find(".".concat(className)).hide();
    };
    /**
     * @param {boolean} enable Enable or false
     */
    VZoom.prototype.set3D = function (enable) {
        this.jqElement_.find(".".concat(ClassName.D3, " .mode")).text(enable ? '3D' : '2D');
    };
    return VZoom;
}(BaseView));
export default VZoom;
//# sourceMappingURL=VZoom.js.map